import React, { memo } from 'react';
import styles from './style.module.css';

export const InputField = (props) => {
  const { label, placeholder, type, customClassName, register, ...rest } =
    props;
  return (
    <div>
      <>
        {label && <p className={styles.input_label}>{label}</p>}
        <input
          placeholder={placeholder}
          className={
            customClassName === 'error' ? styles.error : styles.input_field
          }
          type={type}
          {...register}
          {...rest}
        />
      </>
    </div>
  );
};

export default memo(InputField);
